import pluralize from './pluralize'
import translate from '../misc/translate'

export default function getPluralizedProductTranslation(amount: number) {
  return `${amount} ${pluralize(
    `${translate('shop__product')} |||| ${translate('shop__products')}`,
    amount,
  )}`
}
